import Api from '@/utils/api';
import Multiselect from 'vue-multiselect';
import preloader from '@/components/preloader/index.vue';

export default {
  components: {
    Multiselect,
    preloader,
  },
  data () {
    return {
      metricData: {
        ID: 0,
        Name: '',
        errorCategories: [],
      },
      request: {
        ID: null,
        Name: '',
        AvailableToAll: true,
        JsonErrorCategories: [],
      },
      errorMiltiCategory: [],
      selectedErCatObject: null,
      selectedErrorClass: {},
      multiselectErCat: {},
      showNewItem: false,
      isAnyDataChanged: false,
      load: false,
    };
  },

  created () {
    this.getErrorCategories();
  },
  methods: {
    /**
         * Get error categories with error points for current metric
         */
    getErrorCategories () {
      if (this.$route.params.id === undefined) {
        this.getCategories();
        return;
      }
      this.load = true;
      Api.settings.metricsConfiguration
        .getErrorCategoriesForMetric(this.$route.params.id).then((response) => {
          if (response.data.Status) {
            this.load = false;
            this.metricData.ID = response.data.Data[0].MetricID;
            this.metricData.Name = response.data.Data[0].MetricName;
            this.metricData.errorCategories = response.data.Data.map((value) => {
              this.$set(value, 'ShowEditable', false);
              return value;
            });
            this.getCategories();
          } else {
            this.load = false;
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        }
        );
    },

    nameCategory ({ name }) {
      return `${name}`;
    },

    /**
         * Method for getting error categories for multiselect
         */
    getCategories () {
      Api.settings.metricsConfiguration.getAllErrorCategories().then((response) => {
        if (response.data.Status) {
          this.errorMiltiCategory = response.data.Data.map((el) => {
            this.$set(el, '$isDisabled', false);
            return el;
          });
        }
      });
    },

    /**
         * Method for incrementing minor error poins
         */
    incrementMinor () {
      this.selectedErrorClass.MinorErrorPoints++;
    },

    /**
         * Method for decrementing minor error points
         */
    dicrementMinor () {
      if (this.selectedErrorClass.MinorErrorPoints == 0) {
        return;
      }
      this.selectedErrorClass.MinorErrorPoints--;
    },

    /**
         * Method for incrementing major error poins
         */
    incrementMajor () {
      this.selectedErrorClass.MajorErrorPoints++;
    },

    /**
         * Method for incrementing major error poins
         */
    dicrementMajor () {
      if (this.selectedErrorClass.MajorErrorPoints == 0) {
        return;
      }
      this.selectedErrorClass.MajorErrorPoints--;
    },

    focusInput (input) {
      input.disabled = !input.disabled;
      input.focus();
    },

    /**
         * Method for decrementing error weight
         */
    dicrementCategoryWeight () {
      if (this.selectedErrorClass.CategoryWeight === 0) {
        return;
      }
      this.selectedErrorClass.CategoryWeight -= 0.25;
    },

    /**
         * Method for incrementing error weight
         */
    incrementCategoryWeight () {
      this.selectedErrorClass.CategoryWeight += 0.25;
    },

    resetData () {
      this.getErrorCategories();
    },

    /**
         * Method for saving metric data
         */
    createRequest () {
      this.load = true;
      const tempObj = [];
      this.metricData.errorCategories.forEach((element) => {
        if (element.MajorErrorPoints != 0 || element.MinorErrorPoints != 0) {
          const obj = {
            ErrorCategoryId: element.ErrorCategoryID,
            ErrorPoints: {
              Minor: element.MinorErrorPoints,
              Magor: element.MajorErrorPoints,
              CategoryWeight: element.CategoryWeight,
            },
          };
          tempObj.push(obj);
        }
      });
      var temp = JSON.stringify(tempObj);
      this.request.JsonErrorCategories = temp;
      if (this.$route.params.id == undefined) {
        Api.settings.metricsConfiguration.createMetric(this.request).then((response) => {
          if (response.data.Status) {
            this.load = false;
            this.$root.$emit('notification', {
              message: 'Metric was created!',
              type: 'info',
              show: true,
            });
            this.isAnyDataChanged = false;
            setTimeout(() => {
              this.$router.push('/settings/metrics');
            }, 2000);
          } else {
            this.load = false;
            this.isAnyDataChanged = true;
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
      } else {
        this.request.Name = this.metricData.Name;
        this.request.ID = this.$route.params.id;
        // this.request.AvailableToAll = this.errorCategories.AvailableToAll;
        Api.settings.metricsConfiguration.updateMetric(this.request).then((response) => {
          if (response.data.Status) {
            this.load = false;
            this.$root.$emit('notification', {
              message: 'Metric was updated!',
              type: 'info',
              show: true,
            });
            this.isAnyDataChanged = false;
            setTimeout(() => {
              this.$router.push('/settings/metrics');
            }, 2000);
          } else {
            this.load = false;
            this.isAnyDataChanged = true;
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
      }
    },

    /**
         * Method for making editable fields of error category
         * @param {Object} errorCategoryObj current error category object
         */
    makeEditable (errorCategoryObj) {
      errorCategoryObj.ShowEditable = true;
      this.selectedErrorClass = Object.assign({}, errorCategoryObj);
      this.selectedErCatObject = Object.assign({}, errorCategoryObj);
    },

    /**
         * Method for changing error category data (abbreviation, description)
         * @param {Object} $event - multiselect event object
         */
    errorChange ($event) {
      this.selectedErrorClass.ErrorCategoryID = $event.ErrorCategoryID;
      this.selectedErrorClass.ErrorCategoryName = $event.ErrorCategoryName;
      this.selectedErrorClass.ErrorCategoryAbbreviation = $event.ErrorCategoryAbbreviation;
      this.selectedErrorClass.ErrorCategoryDescription = $event.ErrorCategoryDescription;
    },

    /**
         * Method for making fields editable error category disabled for editing
         * @param {Object} error - editable error category
         */
    endEdit (error) {
      this.selectedErrorClass = {};
      this.selectedErCatObject = {};
      error.ShowEditable = false;
    },

    /**
         * Method for creating error category adding zone
         */
    addErrorCategory () {
      this.selectedErrorClass = {};
      this.selectedErCatObject = null;
      this.$set(this.selectedErrorClass, 'CategoryWeight', 0);
      this.$set(this.selectedErrorClass, 'MinorErrorPoints', 0);
      this.$set(this.selectedErrorClass, 'MajorErrorPoints', 0);
      this.showNewItem = true;
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight + 1000,
        behavior: 'smooth',
      });
    },

    /**
         * Method for resetting data in error category adding zone
         */
    resetAddForm () {
      this.selectedErrorClass = {};
      this.selectedErCatObject = null;
      this.showNewItem = false;
    },

    /**
         * Method for disabling already used error categories
         * (@open multiselect event handler)
         * @param {Object} value - current selected error category
         */
    multiOpen (value) {
      this.errorMiltiCategory.forEach((el) => {
        this.metricData.errorCategories.forEach((cat) => {
          if (cat.ErrorCategoryID == el.ErrorCategoryID) {
            if (!value || cat.ErrorCategoryID != value.ErrorCategoryID) {
              el.$isDisabled = true;
            } else {
              el.$isDisabled = false;
            }
          }
        });
      });
    },

    /**
         * Method for adding new error category
         */
    pushNewCategory () {
      this.$set(this.selectedErrorClass, 'ShowEditable', false);
      this.metricData.errorCategories.push(this.selectedErrorClass);
      this.selectedErrorClass = null;
      this.showNewItem = false;
      this.isAnyDataChanged = true;
    },

    /**
         * Method for updating error categoryies
         * after updating multiselect value
         * @param {Object} $event
         */
    setErrorCategoryName ($event) {
      this.$set(this.selectedErrorClass, 'ErrorCategoryName', $event.ErrorCategoryName);
      this.$set(this.selectedErrorClass, 'ErrorCategoryID', $event.ErrorCategoryID);
    },

    /**
         * Method for updating error category
         * @param {Number} ix - error category array index
         */
    saveChanges (ix) {
      this.metricData.errorCategories[ix] = this.selectedErrorClass;
      this.metricData.errorCategories[ix].ShowEditable = false;
      this.selectedErrorClass = null;
      this.isAnyDataChanged = true;
    },
    /**
         * Method for removing error categroy
         * @param {Number} ix - error category array index
         */
    removeCategory (ix) {
      this.metricData.errorCategories.splice(ix, 1);
      this.isAnyDataChanged = true;
    },

    /**
         * Method for displaing remove error category modal
         * @param {Number} ix - error category array index
         */
    removeHolder (ix) {
      this.$modal.show('dialog', {
        title: 'Are you sure delete this error category?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeCategory(ix);
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    /**
         * Method for handle click back button action
         */
    backHolder () {
      if (!this.isAnyDataChanged) {
        this.$router.push('/settings/metrics');
      } else {
        this.$modal.show('dialog', {
          title: 'You have unsaved changes. Are you want to save them?',
          buttons: [{
            title: 'Yes',
            handler: () => {
              this.$modal.hide('dialog');
              this.createRequest();
            },
          }, {
            title: 'No',
            handler: () => {
              this.$modal.hide('dialog');
              this.$router.push('/settings/metrics');
            },
          }],
        });
      }
    },
  },
};
